import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
interface IconProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  className?: string;
  priority?: boolean;
}
const Icon = t0 => {
  const $ = _c(14);
  const {
    src,
    alt,
    width: t1,
    height,
    fill: t2,
    className,
    priority: t3
  } = t0;
  const width = t1 === undefined ? 16 : t1;
  const fill = t2 === undefined ? false : t2;
  const priority = t3 === undefined ? false : t3;
  const imageHeight = height || width;
  let t4;
  if ($[0] !== fill || $[1] !== imageHeight || $[2] !== width) {
    t4 = fill ? {
      fill: true
    } : {
      width,
      height: imageHeight
    };
    $[0] = fill;
    $[1] = imageHeight;
    $[2] = width;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `dynamic-size ${className || ""}`;
  const t6 = height ? imageHeight : "auto";
  let t7;
  if ($[4] !== t6 || $[5] !== width) {
    t7 = {
      "--width": width,
      "--height": t6
    };
    $[4] = t6;
    $[5] = width;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = t7 as React.CSSProperties;
  let t9;
  if ($[7] !== alt || $[8] !== priority || $[9] !== src || $[10] !== t4 || $[11] !== t5 || $[12] !== t8) {
    t9 = <Image src={src} alt={alt} {...t4} className={t5} style={t8} priority={priority} />;
    $[7] = alt;
    $[8] = priority;
    $[9] = src;
    $[10] = t4;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
export default Icon;